// Every page displays its visibility tier. Structural, not decorative.
//
// 🔴 The handoff's most important non-visual decision, and it corrects a
// mistake in the earlier brief: "Read-only is about writes. Visibility is a
// separate axis. Read-only does not mean public."
//
//   tier 1 — public, indexed. No member names, no plans, no history, no
//            scores. If a page cannot pass that test it is not tier 1.
//   tier 2 — link only. Random slug, noindex, expires.
//   tier 3 — crew, signed in. The default for anything new.
//
// Only tier 1 is built. Tier 3 needs authentication, which needs an ADR before
// implementation — a new capability, not an assumption to slide in. Tier 2
// needs a write path. Both are out of scope here, deliberately.
//
// The badge is rendered from a page's declared tier, so a page cannot be
// promoted by accident: somebody has to change the tier in
// content-src/sections.json, where it is reviewable in a diff.

export const TIERS = {
  1: { label: 'PUBLIC', note: 'Anyone can read this page.' },
  2: { label: 'LINK ONLY', note: 'Reachable only by its link. Not listed, not indexed.' },
  3: { label: 'CREW ONLY', note: 'Not published. Visible to the server, signed in.' },
}

export default function TierBadge({ tier }) {
  const spec = TIERS[tier]
  if (!spec) throw new Error(`unknown visibility tier: ${tier}`)
  return (
    <span className="d2d-tier d2d-micro" data-testid="tier-badge" data-tier={tier}>
      <span className="d2d-tier__dot" aria-hidden="true" />
      {spec.label}
      <span className="d2d-sr-only"> — {spec.note}</span>
    </span>
  )
}
